export default __webpack_public_path__ + "static/sofa.mobile.inspirations-270c6e3645b734069fd997c670955cee.jpg";